import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/personal-data-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient'; /* -------------- */

/* -------------- */
/*    CURRENCY    */
/* -------------- */
export const FIND_ALL_ENABLED_ID_DOCUMENT_TYPES = 'FIND_ALL_ENABLED_ID_DOCUMENT_TYPES';
export const FIND_ENABLED_DOCS_SELECTION_LIST_BY_COUNTRY_CODE =
  'FIND_ENABLED_DOCS_SELECTION_LIST_BY_COUNTRY_CODE';

export const idDocTypeApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const useIdDocTypeApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...idDocTypeApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling id doc type api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const idDocTypeAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
